"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDepartureCityIDAndTransport = void 0;
var _ramda = require("ramda");
var _constants = require("@otpusk/apisearch-toolbox/dist/queries/constants");
var KIEV_ID = '1544';
var KISHINEV_ID = '1831';
var LVIV_ID = '1397';
var TRANSPORT_AIR = 'air';
var TRANSPORT_BUS = 'bus';
var TRANSPORT_NO = 'no';
var createIsAvailableCityByParamsPredicate = function createIsAvailableCityByParamsPredicate(cityID, transport) {
  return function (cities) {
    return (0, _ramda.any)(function (city) {
      return city.id === cityID && (0, _ramda.includes)(transport, city.transports);
    }, cities);
  };
};
var getDepartureCityIDAndTransport = exports.getDepartureCityIDAndTransport = function getDepartureCityIDAndTransport(cities) {
  return (0, _ramda.call)((0, _ramda.cond)([[createIsAvailableCityByParamsPredicate(KIEV_ID, TRANSPORT_BUS), (0, _ramda.always)({
    departureID: KIEV_ID,
    transport: TRANSPORT_BUS
  })], [createIsAvailableCityByParamsPredicate(KISHINEV_ID, TRANSPORT_AIR), (0, _ramda.always)({
    departureID: KISHINEV_ID,
    transport: TRANSPORT_AIR
  })], [createIsAvailableCityByParamsPredicate(LVIV_ID, TRANSPORT_BUS), (0, _ramda.always)({
    departureID: LVIV_ID,
    transport: TRANSPORT_BUS
  })], [_ramda.T, (0, _ramda.always)({
    departureID: _constants.EMPTY_DEPARTURE_VALUE,
    transport: TRANSPORT_NO
  })]]), cities);
};